import React from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import { highlight, setQueryHyperlink } from 'components/lotto/utility/Utility.js';
import AffiliateCta from 'affiliate/AffiliateCta';
import { AFFILIATE_MESSAGES } from 'affiliate/affiliateConfig';
import 'css/dream-cards.css';

function DreamCard({ dream, slug, index }) {
  const showAffiliatePill = index === 0;

  return (
    <article className="dream-card" aria-labelledby={`dream-title-${index}`}>
      <header className="dream-card__header">
        <h3 id={`dream-title-${index}`} className="dream-card__keyword">
          {highlight(dream.dreamKeyword, slug)}
        </h3>
      </header>

      <dl className="dream-card__fields">
        <div className="dream-card__field">
          <dt>ความฝัน</dt>
          <dd>{highlight(dream.description, slug)}</dd>
        </div>
        <div className="dream-card__field">
          <dt>คำทำนาย</dt>
          <dd>{highlight(dream.horo, slug)}</dd>
        </div>
        <div className="dream-card__field dream-card__field--numbers">
          <dt>เลขนำโชค</dt>
          <dd>
            {slug.length < 2
              ? setQueryHyperlink(dream.luckyNumbers, null)
              : setQueryHyperlink(dream.luckyNumbers, slug)}
          </dd>
        </div>
        <div className="dream-card__field dream-card__field--numbers">
          <dt>เลขหลัก</dt>
          <dd>
            {slug.length > 1
              ? setQueryHyperlink(dream.main, null)
              : setQueryHyperlink(dream.main, slug)}
          </dd>
        </div>
        <div className="dream-card__field dream-card__field--numbers">
          <dt>เลขรอง</dt>
          <dd>
            {slug.length > 1
              ? setQueryHyperlink(dream.second, null)
              : setQueryHyperlink(dream.second, slug)}
          </dd>
        </div>
      </dl>

      {showAffiliatePill && (
        <div className="dream-card__shop-hint">
          <span className="dream-card__shop-label">ช้อปของมงคลรับโชค</span>
          <AffiliateCta variant="pill" />
        </div>
      )}
    </article>
  );
}

export default function LottoDreamList({ results, slug }) {
  results?.forEach((r, i) => {
    r.id = i + 1;
  });

  if (!results?.length) return null;

  return (
    <div className="dream-results" role="region" aria-label="ผลลัพธ์ความฝัน">
      <div className="dream-cards" aria-label="รายการความฝัน">
        {results.map((r, i) => (
          <DreamCard key={r.id || i} dream={r} slug={slug} index={i} />
        ))}
      </div>

      <div className="dream-table-wrap" aria-hidden="true">
        <Table>
          <Thead>
            <Tr>
              <Th scope="col">คำหลัก</Th>
              <Th scope="col">ความฝัน</Th>
              <Th scope="col">คำทำนาย</Th>
              <Th scope="col">เลขนำโชค</Th>
              <Th scope="col">เลขหลัก</Th>
              <Th scope="col">เลขรอง</Th>
            </Tr>
          </Thead>
          <Tbody>
            {results.map((r, i) => (
              <Tr key={i}>
                <Td>{highlight(r.dreamKeyword, slug)}</Td>
                <Td>{highlight(r.description, slug)}</Td>
                <Td>{highlight(r.horo, slug)}</Td>
                <Td>
                  {slug.length < 2
                    ? setQueryHyperlink(r.luckyNumbers, null)
                    : setQueryHyperlink(r.luckyNumbers, slug)}
                </Td>
                <Td>
                  {slug.length > 1
                    ? setQueryHyperlink(r.main, null)
                    : setQueryHyperlink(r.main, slug)}
                </Td>
                <Td>
                  {slug.length > 1
                    ? setQueryHyperlink(r.second, null)
                    : setQueryHyperlink(r.second, slug)}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </div>

      <AffiliateCta
        variant="strip"
        message={AFFILIATE_MESSAGES.afterDream}
      />
    </div>
  );
}
